export default __webpack_public_path__ + "static/media/twitter.79874ecb.png";